import { render, staticRenderFns } from "./EditRelatedCompaniesModal.vue?vue&type=template&id=162ff048&"
import script from "./EditRelatedCompaniesModal.vue?vue&type=script&lang=js&"
export * from "./EditRelatedCompaniesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports